import { makeObservable } from 'mobx';
import { observable } from 'mobx';
import { IParameter, ITableParameterProps, ParameterObject } from './types';
import { TableParameter } from './TableParameter';

export class ParametersGroup implements ParameterObject {
  component?: string;
  name: string;
  parameters: Record<string, TableParameter>;
  selection: Set<number> = new Set();

  constructor(params: {
    name: string;
    parameters: Record<string, IParameter>;
    component?: string;
  }) {
    this.component = params.component;
    this.name = params.name;
    this.parameters = Object.fromEntries(
      Object.entries(params.parameters).map(([name, param]) => [
        name,
        new TableParameter(param as ITableParameterProps),
      ]),
    );

    makeObservable(this, {
      parameters: observable,
      selection: observable,
    });
  }

  removeAll() {
    Object.values(this.parameters).forEach((p) => p.clear());
  }

  asPayloadElement(): Record<string, any> {
    return Object.keys(this.parameters).reduce<Record<string, any>>(
      (prev, current) => {
        const elem = this.parameters[current].asPayloadElement();
        elem && (prev[current] = elem);
        return prev;
      },
      {},
    );
  }
}
